import React, { useEffect, useState } from "react";
import "./Hero.css";
const video =
  "https://firebasestorage.googleapis.com/v0/b/jobportal-3f59d.firebasestorage.app/o/Video.mp4?alt=media&token=c6940fe9-98ee-4f35-9e7f-a246bb6c7908";

function Hero() {

   useEffect(() => {
    const title = document.querySelector(".hero-title");

    setTimeout(() => {
      title.classList.add("active");
    }, 200); // small delay for smooth entry
  }, []);

  return (

    <section className="hero">


        {/* VIDEO BACKGROUND */}
     <video
  className="hero-video"
  autoPlay
  muted
  loop
  playsInline
  preload="metadata"
>
        <source src={video} type="video/mp4" />
      </video>

      {/* DARK OVERLAY */}
      <div className="hero-overlay"></div>

      <div className="hero-container" >

        <h1 className="hero-title">
        <span>The Culture Capsule</span> 
        </h1>

      </div>
    </section>

  );
}

export default Hero;